'use client';

import { useEffect, useState, type ComponentType } from 'react';
import { useLoadOnVisible } from '@/components/pages/use-load-on-visible';
import { TeamCarouselServer } from './server';
import type { RootAttorneysProps } from './type';

type TeamCarouselClientType = ComponentType<Omit<RootAttorneysProps, 'children'>>;

export default function LazyTeamCarouselClient({
  attorneys = [],
  showLinks,
}: Omit<RootAttorneysProps, 'children'>) {
  const { ref, shouldLoad } = useLoadOnVisible<HTMLDivElement>();
  const [Client, setClient] = useState<TeamCarouselClientType | null>(null);

  useEffect(() => {
    if (!shouldLoad || Client) return;
    import('./client').then((module) => setClient(() => module.default));
  }, [Client, shouldLoad]);

  return (
    <div ref={ref}>
      {Client ? (
        <Client attorneys={attorneys} showLinks={showLinks} />
      ) : (
        <TeamCarouselServer attorneys={attorneys} showLinks={showLinks} />
      )}
    </div>
  );
}
